import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthContainerComponent } from './components/auth-container/auth-container.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [AuthContainerComponent],
})
export class AuthLayoutModule {}
